import { Component, OnInit, OnDestroy, ViewChild, NgZone } from "@angular/core";
import { Subscription } from "rxjs";
import { ErrorDialogNotifierService } from "./errorDialogNotifier.service";
import { ModalDialogComponent } from "../modal/modalDialog.component";

@Component({
    selector: "error-dialog",
    templateUrl: "./errorDialog.component.html",
    standalone: false
})
export class ErrorDialogComponent implements OnInit, OnDestroy {
    private onShowErrorDialogSubscription: Subscription;
    @ViewChild(ModalDialogComponent, { static: true }) private dialog: ModalDialogComponent;

    public message: string;

    constructor(private zone: NgZone, private errorDialogNotifierService: ErrorDialogNotifierService) {
    }

    public ngOnInit() {
        this.onShowErrorDialogSubscription = this.errorDialogNotifierService.onShowErrorDialog.subscribe((message) => {
            this.zone.run(() => {
                this.open(message);
            });
        });
    }

    public open(message: string) {
        this.message = message;
        this.dialog.open();
    }

    public close() {
        this.dialog.close(null);
    }

    public ngOnDestroy() {
        if (this.onShowErrorDialogSubscription) this.onShowErrorDialogSubscription.unsubscribe();
    }
}